import {DomainStore} from 'shared/store';
import {observable, action} from 'mobx';
import {endpoints, types, t} from 'shared/core';
import {BenefitDivision} from 'stores/benefits';
import {successAlert} from 'shared/tools';

class BenefitDivisionFormState {
  store = new DomainStore();
  backPath;
  history;
  match;

  @observable benefitDivision;
  @observable errors = {};

  receiveProps({backPath, history, match}) {
    this.backPath = backPath;
    this.history = history;
    this.match = match;
  }

  @action async load() {
    await this.store._compose([
      endpoints.BROKER_PORTAL.BENEFIT_DIVISION.with(this.match.params.benefitDivisionId)
    ]);

    this.benefitDivision = new BenefitDivision(
      this.store._getSingle(types.BENEFIT_DIVISION)
    );
  }

  @action async saveBenefitDivision() {
    const {model, errors} = await this.store.patch(this.benefitDivision);
    this.errors = errors;

    if (model) {
      successAlert(t('taxable_benefits.alerts.Benefit Division updated.'));
      this.history.push(this.backPath);
    }
  }
}

export default BenefitDivisionFormState;
